import { useEffect, useRef, useState } from "react";
/**
 * Custom hook to track elapsed time.
 * @param duration - The duration in second.
 * @param active - Whether the timer is active.
 */
export const useElapsed = ({ duration, active, }) => {
    const [elapsed, setElapsed] = useState(false);
    const timerRef = useRef(null);
    useEffect(() => {
        if (!active)
            return;
        setElapsed(false);
        timerRef.current = setTimeout(() => {
            setElapsed(true);
        }, duration * 1000);
        return () => {
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, [active, duration]);
    return elapsed;
};
